module.exports = __webpack_public_path__ + "static/media/lo6.3f1e9a23.png";